import angular from "angular";

angular
    .module('app')
    .component('commentReplyForm', {
        template: require('./comment-reply-form.html'),
        controller: ['$http', 'Notifier', 'trans', 'Auth', 'moment', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, Notifier, trans, Auth, moment) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.comment = $ctrl.resolve.comment;
        $ctrl.text = null;
    };

    $ctrl.submit = function () {

        $ctrl.loading = true;

        let params = {
            course_id: $ctrl.comment.course_id,
            lesson_id: $ctrl.comment.lesson_id,
            parent_id: $ctrl.comment.id,
            text: $ctrl.text
        };

        $http
            .post(`/cabinet/courses/${$ctrl.comment.course_id}/lessons/${$ctrl.comment.lesson_id}/add-comment`, params)
            .then(
                function (response) {

                    $ctrl.loading = false;

                    Notifier.success(trans('Comment reply is sent'), 3);

                    $ctrl.close({
                        $value: {
                            id: response.data.id,
                            course_id: $ctrl.comment.course_id,
                            lesson_id: $ctrl.comment.lesson_id,
                            text: $ctrl.text,
                            user: Auth.user(),
                            created_at: moment(),
                            is_own: true
                        }
                    });
                },
                function (error) {
                    Notifier.error(error.data.message, 3);
                    $ctrl.loading = false;
                }
            );
    };

}
